"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _account = _interopRequireDefault(require("eth-lib/lib/account"));

var _web3Utils = _interopRequireDefault(require("web3-utils"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Account = /*#__PURE__*/function () {
  function Account() {
    var address = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var privateKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var isSignPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    _classCallCheck(this, Account);

    this.address = null;
    this.privateKey = null;
    this.isSignPrefix = isSignPrefix;

    this._signer = function () {
      return Promise.reject("Error. Not signer");
    };

    if (privateKey !== null) {
      this._setPrivateKey(privateKey);

      this.setSigner();
    } else if (address !== null) {
      this._setAddress(address);
    } else {
      throw new Error("Require address or privateKey");
    }
  }

  _createClass(Account, [{
    key: "_setAddress",
    value: function _setAddress(address) {
      if (!_web3Utils["default"].isAddress(address)) {
        throw new Error("Bad address account");
      }

      this.address = _web3Utils["default"].toChecksumAddress(address);
    }
  }, {
    key: "_setPrivateKey",
    value: function _setPrivateKey(privateKey) {
      this._setAddress(_account["default"].fromPrivate(privateKey).address);

      this.privateKey = privateKey;
    }
  }, {
    key: "setSigner",
    value: function setSigner() {
      var _this = this;

      var signer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (signer !== null) {
        this._signer = function (message) {
          return signer(message, _this);
        };
      } else if (this.privateKey) {
        this._signer = function (message) {
          return Promise.resolve(_account["default"].sign(message, _this.privateKey));
        };
      } else {
        throw new Error("Require signer");
      }
    }
  }, {
    key: "sign",
    value: function sign(hash) {
      var message = this.isSignPrefix ? (0, _utils.setPrefix)(hash) : hash;
      return this._signer(message);
    }
  }, {
    key: "recovery",
    value: function recovery(hash, signature) {
      return Account.recovery(hash, signature, this.isSignPrefix);
    }
  }, {
    key: "signMessage",
    value: function signMessage(message) {
      return this.sign(message.getHash());
    }
  }, {
    key: "recoveryMessage",
    value: function recoveryMessage(message) {
      return this.recovery(message.getHash(), message.signature);
    }
  }], [{
    key: "recovery",
    value: function recovery(hash, signature) {
      var isSignPrefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var message = isSignPrefix ? (0, _utils.setPrefix)(hash) : hash;
      return _account["default"].recover(message, signature);
    }
  }, {
    key: "recoveryMessage",
    value: function recoveryMessage(message) {
      var isSignPrefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return Account.recovery(message.getHash(), message.signature, isSignPrefix);
    }
  }]);

  return Account;
}();

exports["default"] = Account;